webpackJsonp([1],Array(23).concat([
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config__ = __webpack_require__(84);





var Firebase = function Firebase() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Firebase);

    __WEBPACK_IMPORTED_MODULE_1_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_2__config__["a" /* default */]);
    return __WEBPACK_IMPORTED_MODULE_1_firebase__;
};

var firebase = new Firebase();

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_myfirebase__);







var Item = function (_DatabaseModel) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Item, _DatabaseModel);

    function Item(ref) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Item);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Item.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Item)).call(this, ref));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Item, [{
        key: 'required',
        value: function required() {
            return [];
        }
    }]);

    return Item;
}(__WEBPACK_IMPORTED_MODULE_5_myfirebase__["DatabaseModel"]);

/* harmony default export */ __webpack_exports__["a"] = (Item);

/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__auth__ = __webpack_require__(86);



var middlewares = [__WEBPACK_IMPORTED_MODULE_0__auth__["a" /* default */]];

/* harmony default export */ __webpack_exports__["a"] = (middlewares);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__routes__ = __webpack_require__(90);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'history',
    base: __dirname,
    routes: __WEBPACK_IMPORTED_MODULE_2__routes__["a" /* default */],
    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0
        };
    }
}));
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, "/"))

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__storage_modules_myfirebase_auth_auth__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__storage_modules_myfirebase_storage_storage__ = __webpack_require__(93);





__webpack_require__(143);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var fcm = __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__["a" /* firebase */].messaging();

var firestore = __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__["a" /* firebase */].firestore();
firestore.settings({ timestampsInSnapshots: true });

var database = __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__["a" /* firebase */].database();

var messages = database.ref().child('messages');

var error = '';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
    modules: {
        auth: __WEBPACK_IMPORTED_MODULE_3__storage_modules_myfirebase_auth_auth__["a" /* default */],
        storage: __WEBPACK_IMPORTED_MODULE_4__storage_modules_myfirebase_storage_storage__["a" /* default */]
    },

    state: {
        database: database.ref(),
        firestore: firestore,
        error: error,
        messaging: fcm,
        firebase: __WEBPACK_IMPORTED_MODULE_2__src_firebase_firebase__["a" /* firebase */]
    },

    mutations: {},

    getters: {},

    actions: {}
}));

/***/ }),
/* 63 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Item__ = __webpack_require__(43);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$auth.check().then(function (user) {}).catch(function (err) {
      console.log(err);
    });
  },
  firebase: function firebase() {
    var _this = this;

    return {
      data: {
        source: this.$myDatabase.child("Solarspot"),
        readyCallback: function readyCallback() {
          _this.ready = true;
        }
      }
    };
  },
  data: function data() {
    return {
      token: "",
      Item: new __WEBPACK_IMPORTED_MODULE_0__models_Item__["a" /* default */](this.$myDatabase.child('item')).init(),
      ready: false,
      koszt: "",
      zuzycie: "",
      moc: ""

    };
  },

  methods: {
    addItem: function addItem() {
      this.$firebaseRefs.data.onDisconnect().cancel();
      this.Item.push();
      this.Item.name = "";
    },
    deleteItem: function deleteItem(key) {
      this.Item.remove(key);
    }
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Item__ = __webpack_require__(43);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$auth.check().then(function (user) {}).catch(function (err) {
      console.log(err);
    });
  },
  firebase: function firebase() {
    var _this = this;

    return {
      data: {
        source: this.$myDatabase.child("Solarspot"),
        readyCallback: function readyCallback() {
          _this.ready = true;
        }
      }
    };
  },
  data: function data() {
    return {
      token: "",
      Item: new __WEBPACK_IMPORTED_MODULE_0__models_Item__["a" /* default */](this.$myDatabase.child('item')).init(),
      ready: false,
      projektant: ['Magdalena Dziełakowska', 'Piotr Szymański', 'Tomasz Tokarski']

    };
  },

  methods: {
    addItem: function addItem() {
      this.$firebaseRefs.data.onDisconnect().cancel();
      this.Item.push();
      this.Item.name = "";
    },
    deleteItem: function deleteItem(key) {
      this.Item.remove(key);
    }
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Person__ = __webpack_require__(87);




/* harmony default export */ __webpack_exports__["default"] = ({
    created: function created() {
        var _this = this;

        this.$binding('Persons', this.$myFirestore.collection('Persons')).then(function (data) {
            _this.ready = true;
        });
    },
    data: function data() {
        return {
            Person: new __WEBPACK_IMPORTED_MODULE_0__models_Person__["a" /* default */](this.$myFirestore.collection('Persons')).init(),
            ready: false
        };
    },

    methods: {
        add: function add() {
            this.Person.add().then(function (success) {}).catch(function (error) {
                console.log(error.message);
            });
            this.Person.name = "";
        },
        remove: function remove(key) {
            this.Person.delete(key).then(function () {}).catch(function (error) {
                console.log(error.message);
            });
        }
    }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router_utils__ = __webpack_require__(91);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$auth.check().then(function (user) {}).catch(function (err) {});
  },
  data: function data() {
    return {
      items: [{ title: 'Real time Database', link: 'dashboard' }, { title: 'Cloud Firestore', link: 'account_box' }],
      drawer: true,
      RoutesUtils: __WEBPACK_IMPORTED_MODULE_0__router_utils__["a" /* default */].navigarion
    };
  },

  methods: {
    logout: function logout() {
      var _this = this;

      this.$auth.logout().then(function () {
        _this.$router.push('/login');
      });
    },
    login: function login() {
      this.$router.push('/login');
    }
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Solarspot__ = __webpack_require__(89);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    this.$auth.check().then(function (user) {}).catch(function (err) {
      alert(err);
    });
  },
  firebase: function firebase() {
    var _this = this;

    return {
      data: {
        source: this.$myDatabase.child("Solarspot"),
        readyCallback: function readyCallback() {
          _this.ready = true;
        }
      }
    };
  },
  data: function data() {
    return {
      token: "",
      Item: new __WEBPACK_IMPORTED_MODULE_0__models_Solarspot__["a" /* default */](this.$myDatabase.child('Solarspot')).init(),
      ready: false,
      items: ['Osoba prywatna', 'Firma', 'Gospodarstwo rolne'],
      yesno: ['Tak', 'Nie'],
      rodzajdachu: ['Dach płaski', 'Dach jednospadowy', 'Dach dwuspadowy', 'Dach czterospadowy'],
      wymiarybyly: ['Zmierzone', 'Oszacowane'],
      istniejaca: ['1 Fazowa', '3 Fazowa'],
      odgromowa: ['Istnieje', 'Nie istnieje'],
      izolacja: ['Izolacja wierzchna', 'Izolacja spodnia', 'Brak izolacji'],
      materialkrokwi: ['Drewno', 'Stal', 'eton'],
      typdachu: ['Dach krokwiowy', 'Dach płatowy', 'Dach płaski'],
      dostawca: ['PGE', 'Tauron', 'Enea', 'Energa', 'Innogy'],
      projekt: false,
      osd: false,
      realizacja: false

    };
  },

  methods: {
    addItem: function addItem() {
      this.$firebaseRefs.data.onDisconnect().cancel();
      this.Item.push().catch(function (err) {
        if (err) {
          alert('Wystąpił błąd spróbuj później lub skontaktuj się z administratorem' + '\n' + err);
        }
      });
      this.Item.rodzajKlienta = "";
      this.Item.nazwa = "";
      this.Item.ulica = "";
      this.Item.miasto = "";
      this.Item.gmina = "";
      this.Item.kod = "";
      this.Item.telefon = "";
      this.Item.email = "";
      this.Item.moc = "";
      this.Item.projektDachu = "";
      this.Item.rodzajDachu = "";
      this.Item.wymiaryByly = "";
      this.Item.dlugosc = "";
      this.Item.szerokosc = "";
      this.Item.dlugoscDachu = "";
      this.Item.kat = "";
      this.Item.istniejaca = "";
      this.Item.przekrojPrzewodu = "";
      this.Item.zabezpieczenie = "";
      this.Item.odgromowa = "";
      this.Item.izolacja = "";
      this.Item.gruboscIzlolacji = "";
      this.Item.materialIzlolacji = "";
      this.Item.typDachu = "";
      this.Item.materialKrokwi = "";
      this.Item.odlegloscKrokwi = "";
      this.Item.gruboscKrokwi = "";
      this.Item.gruboscKrokwi = "";
      this.Item.dostawca = "";
      this.Item.nabywca = "";
      this.Item.wartoscZabezpieczenia = "";
      this.Item.ppe = "";
      this.Item.nrLicznika = "";
      this.Item.mocPrzylaczeniowa = "";
      this.Item.mocUmowna = "";
    },
    deleteItem: function deleteItem(key) {
      this.Item.remove(key);
    }
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {
        this.$auth.check().then(function (user) {}).catch(function (err) {});
    },
    data: function data() {
        return {};
    }
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.$auth.logout();
    this.$auth.state("/realtime-database", "/login").then(function (user) {
      if (!user) {
        _this.ready = false;
      }
    });
  },
  data: function data() {
    return {
      snackbar: false,
      email: "",
      password: "",
      company: "SolarSopot",
      error: "",
      ready: false,
      emailRules: [function (v) {
        return !!v || "E-mail is required";
      }, function (v) {
        return (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) || "E-mail must be valid"
        );
      }],
      e3: true
    };
  },

  computed: {},
  methods: {
    login: function login() {
      var _this2 = this;

      this.ready = true;
      this.$auth.logout();
      this.$auth.loginWithEmailAndPassword(this.email, this.password).then(function (user) {
        _this2.ready = false;
      }).catch(function (error) {
        _this2.snackbar = true;
        _this2.ready = false;
        _this2.error = error.message;
      });
    },
    register: function register() {
      var _this3 = this;

      this.ready = true;
      this.$auth.registerWithEmailAndPassword(this.email, this.password, this.company).then(function (user) {
        _this3.ready = false;
      }).catch(function (error) {
        _this3.error = error.message;
        _this3.ready = false;
        _this3.snackbar = true;
      });
    },
    signInGoogle: function signInGoogle() {
      var _this4 = this;

      this.ready = true;
      this.$auth.signInWithGoogle().then(function (result) {
        _this4.ready = false;
      }).catch(function (error) {
        _this4.error = error.message;
        _this4.ready = false;
        _this4.snackbar = true;
      });
    },
    signInFacebook: function signInFacebook() {
      var _this5 = this;

      this.ready = true;
      this.$auth.signInWithFacebook().then(function (result) {
        _this5.ready = false;
      }).catch(function (error) {
        _this5.error = error.message;
        _this5.ready = false;
        _this5.snackbar = true;
      });
    },
    signInTwitter: function signInTwitter() {
      var _this6 = this;

      this.ready = true;
      this.$auth.signInWithTwitter().then(function (result) {
        return _this6.ready = false;
      }).catch(function (error) {
        _this6.error = error.message;
        _this6.ready = false;
        _this6.snackbar = true;
      });
    },
    signInGithub: function signInGithub() {
      var _this7 = this;

      this.ready = true;
      this.$auth.signInWithGithub().then(function (result) {
        return _this7.ready = false;
      }).catch(function (error) {
        _this7.error = error.message;
        _this7.ready = false;
        _this7.snackbar = true;
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    }
  }
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__models_Profile__ = __webpack_require__(88);




/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    var _this = this;

    this.$auth.check().then(function (user) {
      _this.Profile.setPhotoURL(user.photoURL).setDisplayName(user.displayName).setEmail(user.email);
      _this.ready = false;
    });
  },
  data: function data() {
    return {
      message: '',
      selectedPhoto: { name: '' },
      error: '',
      snackbar: false,
      ready: true,
      Profile: new __WEBPACK_IMPORTED_MODULE_0__models_Profile__["a" /* default */]()
    };
  },

  computed: {},
  methods: {
    getFile: function getFile(e) {
      this.selectedPhoto = e.target.files[0];
    },
    updateAvatar: function updateAvatar() {
      var _this2 = this;

      if (!this.selectedPhoto) {
        return;
      }
      this.ready = true;
      var name = this.selectedPhoto.name;
      this.$storage.upload({
        ref: '/images/' + name,
        file: this.selectedPhoto,
        progress: function progress(snapshot) {},
        error: function error(err) {
          _this2.message = err.message;
          _this2.snackbar = true;
        },
        completed: function completed(downloadURL) {
          _this2.updateProfilePicture(downloadURL).then(function () {
            _this2.message = 'Your profile info has been updated';
            _this2.snackbar = true;
            _this2.selectedPhoto = { name: "" };
            _this2.ready = false;
          }).catch(function (error) {
            _this2.message = error.message;
            _this2.snackbar = true;
          });
        }
      });
    },
    updateProfilePicture: function updateProfilePicture(fileName) {
      return this.$auth.updateProfilePicture(fileName);
    },
    updateProfile: function updateProfile() {
      var _this3 = this;

      this.ready = true;
      this.$auth.user().updateProfile(this.Profile.toJson()).then(function () {
        if (_this3.selectedPhoto.type != undefined) {
          _this3.updateAvatar();
        } else {
          _this3.message = 'Your profile info has been updated';
          _this3.snackbar = true;
          _this3.ready = false;
        }
      }).catch(function (error) {
        _this3.message = error.message;
        _this3.snackbar = true;
        _this3.ready = false;
      });
    },
    synchronize: function synchronize() {
      this.Profile.setPhotoURL(this.$auth.user().photoURL);
    }
  }
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    mounted: function mounted() {},
    data: function data() {
        return {};
    }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var config = {
    apiKey: "AIzaSyAnfbUe0zXqkdACvQCyFKQTIHb8Hqxkjp8",
    authDomain: "eprojektant-1aad2.firebaseapp.com",
    databaseURL: "https://eprojektant-1aad2.firebaseio.com",
    projectId: "eprojektant-1aad2",
    storageBucket: "eprojektant-1aad2.appspot.com",
    messagingSenderId: "987992049786"
};

/* harmony default export */ __webpack_exports__["a"] = (config);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__storage_store__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuefire___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuefire__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_myfirebase__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_myfirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_myfirebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__middlewares_index__ = __webpack_require__(60);

__webpack_require__(63);










__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vuetify___default.a);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuefire___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_firestore___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_myfirebase___default.a, {
    store: __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */],
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    middlewares: __WEBPACK_IMPORTED_MODULE_7__middlewares_index__["a" /* default */]
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
    router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */],
    store: __WEBPACK_IMPORTED_MODULE_2__storage_store__["a" /* default */],
    mounted: function mounted() {
        var env = "production";
        if ('serviceWorker' in navigator && env == 'production') {
            navigator.serviceWorker.register('/service-worker.js');
            navigator.serviceWorker.register('/firebase-messaging-sw.js');
            this.$store.state.messaging.requestPermission().then(function () {
                console.log("Permission accepted");
            }).catch(function (error) {
                console.log("Permission denied");
            });
        }
    },
    data: function data() {
        return {};
    }
}).$mount('#app');

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var AuthMiddleware = function AuthMiddleware(myfirebase, actions) {
  if (actions.to.matched.some(function (record) {
    return record.meta.auth;
  })) {
    myfirebase.auth.check().then(function (user) {
      actions.next();
    }).catch(function (err) {
      actions.next({ path: '/login' });
    });
  } else {
    actions.next();
  }
};

/* harmony default export */ __webpack_exports__["a"] = (AuthMiddleware);

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_myfirebase__);







var Person = function (_FirestoreModel) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Person, _FirestoreModel);

    function Person(ref) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Person);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Person.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Person)).call(this, ref));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Person, [{
        key: 'required',
        value: function required() {
            return [];
        }
    }]);

    return Person;
}(__WEBPACK_IMPORTED_MODULE_5_myfirebase__["FirestoreModel"]);

/* harmony default export */ __webpack_exports__["a"] = (Person);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var Profile = function () {
    function Profile() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Profile);

        this.email = "";
        this.displayName = "";
        this.photoURL = "";
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Profile, [{
        key: "setEmail",
        value: function setEmail(email) {
            this.email = email;
            return this;
        }
    }, {
        key: "setDisplayName",
        value: function setDisplayName(displayName) {
            this.displayName = displayName;
            return this;
        }
    }, {
        key: "setPhotoURL",
        value: function setPhotoURL(photoURL) {
            this.photoURL = photoURL;
            return this;
        }
    }, {
        key: "toJson",
        value: function toJson() {
            return {
                email: this.email,
                displayName: this.displayName
            };
        }
    }]);

    return Profile;
}();

/* harmony default export */ __webpack_exports__["a"] = (Profile);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_myfirebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_myfirebase__);







var Solarspot = function (_DatabaseModel) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(Solarspot, _DatabaseModel);

    function Solarspot(ref) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Solarspot);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Solarspot.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Solarspot)).call(this, ref));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Solarspot, [{
        key: 'required',
        value: function required() {
            return [];
        }
    }]);

    return Solarspot;
}(__WEBPACK_IMPORTED_MODULE_5_myfirebase__["DatabaseModel"]);

/* harmony default export */ __webpack_exports__["a"] = (Solarspot);

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Layout___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Layout__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Welcome__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Welcome___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Welcome__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_Login__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_auth_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_auth_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_App2__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_App2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_App2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_errors_404__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_errors_404___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_errors_404__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Firestore__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_Firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Solarspot__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Solarspot___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_Solarspot__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue__ = __webpack_require__(13);












var routes = [{
    path: '/',
    component: __WEBPACK_IMPORTED_MODULE_0__components_Layout___default.a,
    children: [{
        path: '/',
        component: __WEBPACK_IMPORTED_MODULE_1__components_Welcome___default.a,
        name: 'Welcome'
    }, {
        path: '/login',
        component: __WEBPACK_IMPORTED_MODULE_2__components_auth_Login___default.a,
        name: 'login'
    }, {
        path: '/update-profile',
        component: __WEBPACK_IMPORTED_MODULE_3__components_auth_UpdateProfile___default.a,
        name: 'Profile Update',
        meta: {
            auth: true
        }
    }, {
        path: '/kontakt',
        component: __WEBPACK_IMPORTED_MODULE_5__components_App2___default.a,
        name: 'Realtime Database2',
        meta: {
            auth: true
        }
    }, {
        path: '/realtime-database',
        component: __WEBPACK_IMPORTED_MODULE_4__components_App___default.a,
        name: 'Realtime Database',
        meta: {
            auth: true
        }
    }, {
        path: '/firestore',
        component: __WEBPACK_IMPORTED_MODULE_7__components_Firestore___default.a,
        name: 'Cloud Firestore',
        meta: {
            auth: true
        }
    }, {
        path: '/solarspot',
        component: __WEBPACK_IMPORTED_MODULE_8__components_Solarspot___default.a,
        name: 'Solarspot',
        meta: {
            auth: true
        }
    }, {
        path: '*',
        component: __WEBPACK_IMPORTED_MODULE_6__components_errors_404___default.a
    }]
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var UTILS = {
  navigarion: {
    github: function github() {
      window.location.replace("https://github.com/myfirebase/myfirebase");
    },
    docs: function docs() {
      window.location.replace("https://myfirebase.github.io");
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (UTILS);

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__ = __webpack_require__(23);


var auth = __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__["a" /* firebase */].auth();

var error = '';

var googleAuthProvider = new __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__["a" /* firebase */].auth.GoogleAuthProvider();

var facebookAuthProvider = new __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__["a" /* firebase */].auth.FacebookAuthProvider();

var twitterAuthProvider = new __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__["a" /* firebase */].auth.TwitterAuthProvider();

var githubAuthProvider = new __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__["a" /* firebase */].auth.GithubAuthProvider();

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        auth: auth,
        error: error,
        googleAuthProvider: googleAuthProvider,
        facebookAuthProvider: facebookAuthProvider,
        twitterAuthProvider: twitterAuthProvider,
        githubAuthProvider: githubAuthProvider
    },
    mutations: {},
    getters: {},
    actions: {
        login: function login(context, user) {
            return context.state.auth.signInWithEmailAndPassword(user.email, user.password);
        },
        logout: function logout(context) {
            return context.state.auth.signOut();
        },
        register: function register(context, user) {
            return context.state.auth.createUserWithEmailAndPassword(user.email, user.password);
        },
        signInGoogle: function signInGoogle(context) {
            var provider = context.state.googleAuthProvider;
            return context.state.auth.signInWithPopup(provider);
        },
        signInFacebook: function signInFacebook(context) {
            var provider = context.state.facebookAuthProvider;
            return context.state.auth.signInWithPopup(provider);
        },
        signInTwitter: function signInTwitter(context) {
            var provider = context.state.twitterAuthProvider;
            return context.state.auth.signInWithPopup(provider);
        },
        signInGithub: function signInGithub(context) {
            var provider = context.state.githubAuthProvider;
            return context.state.auth.signInWithPopup(provider);
        },
        updateProfilePicture: function updateProfilePicture(context, image) {
            return context.state.auth.currentUser.updateProfile({
                photoURL: image
            });
        }
    }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__ = __webpack_require__(23);


var storage = __WEBPACK_IMPORTED_MODULE_0__src_firebase_firebase__["a" /* firebase */].storage();

var error = '';

/* harmony default export */ __webpack_exports__["a"] = ({
    namespaced: true,
    state: {
        storage: storage,
        error: error
    },
    mutations: {
        uploadFile: function uploadFile(state, file) {
            var task = state.storage.ref().child(file.ref).put(file.file);
            task.on('state_changed', function progress(snapshot) {
                file.progress(snapshot);
            }, function error(err) {
                file.error(err);
            }, function completed() {
                task.snapshot.ref.getDownloadURL().then(function (url) {
                    file.completed(url);
                });
            });
        },
        uploadFiles: function uploadFiles(state, files) {
            for (var key in files.files) {
                if (files.files.hasOwnProperty(key)) {
                    var task = state.storage.ref().child(files.ref + '/' + files.files[key].name).put(files.files[key]);
                    task.on('state_changed', function progress(snapshot) {
                        files.progress(snapshot);
                    }, function error(err) {
                        files.error(err);
                    }, function completed() {
                        files.completed();
                    });
                }
            }
        }
    },
    actions: {
        deleteFile: function deleteFile(context, file) {
            return context.state.storage.ref().child(file).delete();
        }
    },
    getters: {}
});

/***/ }),
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(141)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(163),
  /* scopeId */
  "data-v-ed558526",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(140)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(162),
  /* scopeId */
  "data-v-bd2bccd6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(139)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(161),
  /* scopeId */
  "data-v-b7056892",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(138)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(160),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(134)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(156),
  /* scopeId */
  "data-v-557bfce2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(133)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(155),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(137)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(159),
  /* scopeId */
  "data-v-6fe6bde6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(136)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(82),
  /* template */
  __webpack_require__(158),
  /* scopeId */
  "data-v-66914a9d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(135)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(157),
  /* scopeId */
  "data-v-648d4d50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg"
  }, [_c('div', {
    staticClass: "flex"
  }, [_c('p', {
    staticClass: "display-3 font-weight-thin"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": __webpack_require__(145),
      "alt": "MyfirebaseLogo"
    }
  }), _vm._v(" "), _c('br'), _c('span', {
    staticClass: "colorw"
  }, [_vm._v("Witaj w aplikacji")]), _c('br'), _vm._v(" "), (_vm.$auth.user()) ? _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Wyloguj się")]) : _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.$router.push('/login')
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-subheader', {
    staticClass: "title",
    attrs: {
      "id": "top"
    }
  }, [_vm._v("USTALENIA MONTAŻOWE")]), _vm._v(" "), _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "accent--text",
    attrs: {
      "label": "Projekt instalacji"
    },
    model: {
      value: (_vm.projekt),
      callback: function($$v) {
        _vm.projekt = $$v
      },
      expression: "projekt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "col",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Doradztwo techniczne podczas realizacji"
    },
    model: {
      value: (_vm.realizacja),
      callback: function($$v) {
        _vm.realizacja = $$v
      },
      expression: "realizacja"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "col",
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "Doradztwo w zakresie OSD"
    },
    model: {
      value: (_vm.osd),
      callback: function($$v) {
        _vm.osd = $$v
      },
      expression: "osd"
    }
  })], 1)], 1), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title2"
  }, [_vm._v("Projekt instalacji fotowoltaicznej")]), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("A) Podstawowe dane klienta")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.items,
      "label": "Rodzaj klienta"
    },
    model: {
      value: (_vm.Item.rodzajKlienta),
      callback: function($$v) {
        _vm.$set(_vm.Item, "rodzajKlienta", $$v)
      },
      expression: "Item.rodzajKlienta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Imię i Nazwisko / Firma"
    },
    model: {
      value: (_vm.Item.nazwa),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nazwa", $$v)
      },
      expression: "Item.nazwa"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Ulica i numer"
    },
    model: {
      value: (_vm.Item.ulica),
      callback: function($$v) {
        _vm.$set(_vm.Item, "ulica", $$v)
      },
      expression: "Item.ulica"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Miejscowość"
    },
    model: {
      value: (_vm.Item.miasto),
      callback: function($$v) {
        _vm.$set(_vm.Item, "miasto", $$v)
      },
      expression: "Item.miasto"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Gmina"
    },
    model: {
      value: (_vm.Item.gmina),
      callback: function($$v) {
        _vm.$set(_vm.Item, "gmina", $$v)
      },
      expression: "Item.gmina"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Kod pocztowy"
    },
    model: {
      value: (_vm.Item.kod),
      callback: function($$v) {
        _vm.$set(_vm.Item, "kod", $$v)
      },
      expression: "Item.kod"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Telefon",
      "type": "tel"
    },
    model: {
      value: (_vm.Item.telefon),
      callback: function($$v) {
        _vm.$set(_vm.Item, "telefon", $$v)
      },
      expression: "Item.telefon"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "E-mail",
      "type": "email"
    },
    model: {
      value: (_vm.Item.email),
      callback: function($$v) {
        _vm.$set(_vm.Item, "email", $$v)
      },
      expression: "Item.email"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("B) Jaką klient rozpatruje moc instalacji np. 4-5kW")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Moc instalacji [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.moc),
      callback: function($$v) {
        _vm.$set(_vm.Item, "moc", $$v)
      },
      expression: "Item.moc"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("C) Podstawowe wymiary obiektu")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.yesno,
      "label": "Czy istnieje możliwość dołączenia projektu dachu?"
    },
    model: {
      value: (_vm.Item.projektDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "projektDachu", $$v)
      },
      expression: "Item.projektDachu"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.rodzajdachu,
      "label": "Rodzaj dachu"
    },
    model: {
      value: (_vm.Item.rodzajDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "rodzajDachu", $$v)
      },
      expression: "Item.rodzajDachu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Długość obiektu [m]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.dlugosc),
      callback: function($$v) {
        _vm.$set(_vm.Item, "dlugosc", $$v)
      },
      expression: "Item.dlugosc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Szerokość obiektu [m]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.szerokosc),
      callback: function($$v) {
        _vm.$set(_vm.Item, "szerokosc", $$v)
      },
      expression: "Item.szerokosc"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Długość krawędzi dachu [m]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.dlugoscDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "dlugoscDachu", $$v)
      },
      expression: "Item.dlugoscDachu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Kąt pochylenia dachu [°]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.kat),
      callback: function($$v) {
        _vm.$set(_vm.Item, "kat", $$v)
      },
      expression: "Item.kat"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.wymiarybyly,
      "label": "Wymiary zostały"
    },
    model: {
      value: (_vm.Item.wymiaryByly),
      callback: function($$v) {
        _vm.$set(_vm.Item, "wymiaryByly", $$v)
      },
      expression: "Item.wymiaryByly"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    staticClass: "title3"
  }, [_vm._v("D) Elektryka obiektu")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.istniejaca,
      "label": "Instalacja istniejąca"
    },
    model: {
      value: (_vm.Item.istniejaca),
      callback: function($$v) {
        _vm.$set(_vm.Item, "istniejaca", $$v)
      },
      expression: "Item.istniejaca"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Przekrój przewodów w instalacji elektycznej [mm2]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.przekrojPrzewodu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "przekrojPrzewodu", $$v)
      },
      expression: "Item.przekrojPrzewodu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "label": "Wartość zabezpieczenia przedlicznikowego [A]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.zabezpieczenie),
      callback: function($$v) {
        _vm.$set(_vm.Item, "zabezpieczenie", $$v)
      },
      expression: "Item.zabezpieczenie"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.projekt),
      expression: "projekt"
    }],
    attrs: {
      "items": _vm.odgromowa,
      "label": "Instalacja odgromowa"
    },
    model: {
      value: (_vm.Item.odgromowa),
      callback: function($$v) {
        _vm.$set(_vm.Item, "odgromowa", $$v)
      },
      expression: "Item.odgromowa"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    staticClass: "title2"
  }, [_vm._v("Doradztwo techniczne podczas realizacji")]), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    staticClass: "title3"
  }, [_vm._v("A)")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "items": _vm.izolacja,
      "label": "Instalacja istniejąca"
    },
    model: {
      value: (_vm.Item.izolacja),
      callback: function($$v) {
        _vm.$set(_vm.Item, "izolacja", $$v)
      },
      expression: "Item.izolacja"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Grubość izolacji [mm]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.gruboscIzlolacji),
      callback: function($$v) {
        _vm.$set(_vm.Item, "gruboscIzlolacji", $$v)
      },
      expression: "Item.gruboscIzlolacji"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Materiał izloacji"
    },
    model: {
      value: (_vm.Item.materialIzlolacji),
      callback: function($$v) {
        _vm.$set(_vm.Item, "materialIzlolacji", $$v)
      },
      expression: "Item.materialIzlolacji"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "items": _vm.materialkrokwi,
      "label": "Materiał krokwi/płatw"
    },
    model: {
      value: (_vm.Item.materialKrokwi),
      callback: function($$v) {
        _vm.$set(_vm.Item, "materialKrokwi", $$v)
      },
      expression: "Item.materialKrokwi"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    staticClass: "title3"
  }, [_vm._v("B)")]), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "items": _vm.typdachu,
      "label": "Rodzaj dachu"
    },
    model: {
      value: (_vm.Item.typDachu),
      callback: function($$v) {
        _vm.$set(_vm.Item, "typDachu", $$v)
      },
      expression: "Item.typDachu"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Odległość między krokwiami/płatami [mm]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.odlegloscKrokwi),
      callback: function($$v) {
        _vm.$set(_vm.Item, "odlegloscKrokwi", $$v)
      },
      expression: "Item.odlegloscKrokwi"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.realizacja),
      expression: "realizacja"
    }],
    attrs: {
      "label": "Grubość krokwiami/płatwi [mm]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.gruboscKrokwi),
      callback: function($$v) {
        _vm.$set(_vm.Item, "gruboscKrokwi", $$v)
      },
      expression: "Item.gruboscKrokwi"
    }
  }), _vm._v(" "), _c('v-subheader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    staticClass: "title2"
  }, [_vm._v("Doradztwo w zakresie OSD")]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nr ewidencyjny działki"
    },
    model: {
      value: (_vm.Item.nrEwidencji),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nrEwidencji", $$v)
      },
      expression: "Item.nrEwidencji"
    }
  }), _vm._v(" "), _c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "items": _vm.dostawca,
      "label": "Dostawca energii elektrycznej"
    },
    model: {
      value: (_vm.Item.dostawca),
      callback: function($$v) {
        _vm.$set(_vm.Item, "dostawca", $$v)
      },
      expression: "Item.dostawca"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nabywca energii z faktury"
    },
    model: {
      value: (_vm.Item.nabywca),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nabywca", $$v)
      },
      expression: "Item.nabywca"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Wartość zabezpieczenia przedlicznikowego [A]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.wartoscZabezpieczenia),
      callback: function($$v) {
        _vm.$set(_vm.Item, "wartoscZabezpieczenia", $$v)
      },
      expression: "Item.wartoscZabezpieczenia"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nr PPE (Punkt Poboru Energii)"
    },
    model: {
      value: (_vm.Item.ppe),
      callback: function($$v) {
        _vm.$set(_vm.Item, "ppe", $$v)
      },
      expression: "Item.ppe"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Nr licznika"
    },
    model: {
      value: (_vm.Item.nrLicznika),
      callback: function($$v) {
        _vm.$set(_vm.Item, "nrLicznika", $$v)
      },
      expression: "Item.nrLicznika"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Moc przyłączeniowa [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.mocPrzylaczeniowa),
      callback: function($$v) {
        _vm.$set(_vm.Item, "mocPrzylaczeniowa", $$v)
      },
      expression: "Item.mocPrzylaczeniowa"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.osd),
      expression: "osd"
    }],
    attrs: {
      "label": "Moc umowna [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.Item.mocUmowna),
      callback: function($$v) {
        _vm.$set(_vm.Item, "mocUmowna", $$v)
      },
      expression: "Item.mocUmowna"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.addItem()
      }
    }
  }, [_vm._v("Wyślij")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Page Not Found")]), _vm._v(" "), _c('p', [_vm._v("This specified file was not found on this website. Please check the URL for mistakes and try again.")]), _vm._v(" "), _c('h2', [_vm._v("Why am I seeing this?")]), _vm._v(" "), _c('p', [_vm._v("This page was generated by the Firebase Command-Line Interface. To modify it, edit the\n        "), _c('code', [_vm._v("404.html")]), _vm._v(" file in your project's configured public directory.")]), _vm._v(" "), _c('a', {
    staticClass: "logo",
    attrs: {
      "href": "//firebase.google.com"
    }
  }, [_c('img', {
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])])
}]}

/***/ }),
/* 158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("PROFIL UŻYTKOWNIKA")]), _vm._v(" "), _c('v-card-title', [_c('div', [_c('v-text-field', {
    staticClass: "rozmiar",
    attrs: {
      "label": "E-mail"
    },
    model: {
      value: (_vm.Profile.email),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "email", $$v)
      },
      expression: "Profile.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    staticClass: "rozmiar",
    attrs: {
      "label": "Imię i Nazwisko"
    },
    model: {
      value: (_vm.Profile.displayName),
      callback: function($$v) {
        _vm.$set(_vm.Profile, "displayName", $$v)
      },
      expression: "Profile.displayName"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        _vm.updateProfile()
      }
    }
  }, [_vm._v("Aktualizuj profil")])], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": false,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.message) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-auto"
  }, [_c('img', {
    staticClass: "logo",
    staticStyle: {
      "height": "68px"
    },
    attrs: {
      "src": __webpack_require__(59),
      "alt": "SolarSpot logo"
    }
  }), _vm._v(" "), _c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_c('div', [_c('h3', {
    staticClass: "headline mb-0"
  }, [_vm._v("Zaloguj się")])])]), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "rules": _vm.emailRules,
      "label": "E-mail",
      "required": ""
    },
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": _vm.e3 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e3 = !_vm.e3); },
      "type": _vm.e3 ? 'password' : 'text',
      "name": "input-10-2",
      "label": "Hasło",
      "hint": "At least 8 characters",
      "min": "8",
      "value": "",
      "required": ""
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.login
    }
  }, [_vm._v("\n              Zaloguj się\n            ")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.register
    }
  }, [_vm._v("\n              Przypomnij hasło\n            ")])], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "timeout": 6000,
      "top": true,
      "bottom": false,
      "right": false,
      "left": false,
      "multi-line": false,
      "vertical": true
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.error) + "\n    "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "pink"
    },
    nativeOn: {
      "click": function($event) {
        _vm.snackbar = false
      }
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), (_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.$auth.user()) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "permanent": _vm.drawer,
      "hide-overlay": "",
      "width": "200"
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "transparent",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0"
  }, [_c('v-list-tile', {
    attrs: {
      "avatar": ""
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "person"
  }, [_vm._v(_vm._s(_vm.$auth.user().displayName || _vm.$auth.user().email))])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/realtime-database')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Kalkulator")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/Solarspot')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Ustalenia montażowe")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/Kontakt')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Kontakt z projektantem")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.$router.push('/update-profile')
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Aktualizacja profilu")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Wyloguj się")])], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "app": ""
    }
  }, [(_vm.$auth.user()) ? _c('v-toolbar-side-icon', {
    nativeOn: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "logo",
    staticStyle: {
      "height": "36px"
    },
    attrs: {
      "src": __webpack_require__(59),
      "alt": "SolarSpot logo"
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("App")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-items', {
    staticClass: "hidden-sm-and-down"
  }, [(_vm.$auth.user()) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.logout()
      }
    }
  }, [_vm._v("Wyloguj się")]) : _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Zaloguj się")])], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-container', [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    attrs: {
      "app": ""
    }
  }, [_c('span', {
    staticClass: "footer"
  }, [_vm._v("© 2019 www.ecoprojektant.pl")]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 161 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', [_vm._v("Persons")]), _vm._v(" "), _vm._l((_vm.Persons), function(person, index) {
    return _c('v-list-tile', {
      key: index
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(person.name))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "black"
      },
      on: {
        "click": function($event) {
          _vm.remove(person['.key'])
        }
      }
    }, [_vm._v("delete")])], 1)], 1)
  })], 2), _vm._v(" "), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Person Name"
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        _vm.add()
      }
    },
    model: {
      value: (_vm.Person.name),
      callback: function($$v) {
        _vm.$set(_vm.Person, "name", $$v)
      },
      expression: "Person.name"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("Add Person")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("KONTAKT Z PROJEKTANTEM")])], 1), _vm._v(" "), _c('v-subheader', {
    staticClass: "title2"
  }, [_vm._v("Magdalena Dziełakowska")]), _vm._v(" "), _c('p', [_vm._v("Zakres pomocy: Projektowanie w PV*Sol oraz ekonomika inwetycji")]), _vm._v(" "), _c('v-subheader', {
    staticClass: "title2"
  }, [_vm._v("Piotr Szymański")]), _vm._v(" "), _c('p', [_vm._v("Zakres pomocy: Nadzór nad projektami oraz kontakt z dostawcami energii")]), _vm._v(" "), _c('v-subheader', {
    staticClass: "title2"
  }, [_vm._v("Tomasz Tokarski")]), _vm._v(" "), _c('p', [_vm._v("Zakres pomocy: Wykonywanie pomiarów i zdjęć dronem oraz modeli 3d")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-container', [_c('v-select', {
    attrs: {
      "items": _vm.projektant,
      "label": "Wybierz projektanta"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Temat"
    },
    model: {
      value: (_vm.koszt),
      callback: function($$v) {
        _vm.koszt = $$v
      },
      expression: "koszt"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "label": "Treść pytania",
      "type": "number"
    },
    model: {
      value: (_vm.moc),
      callback: function($$v) {
        _vm.moc = $$v
      },
      expression: "moc"
    }
  }), _vm._v(" "), _c('v-btn', [_vm._v("Wyślij")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-list', {
    attrs: {
      "two-line": "",
      "subheader": ""
    }
  }, [_c('v-subheader', {
    staticClass: "title"
  }, [_vm._v("KALKULATOR INSTALACJI FOTOWOLTAICZNEJ")])], 1), _vm._v(" "), _c('v-container', [_c('v-text-field', {
    attrs: {
      "label": "Roczny koszt energii [zł]",
      "type": "number"
    },
    model: {
      value: (_vm.koszt),
      callback: function($$v) {
        _vm.koszt = $$v
      },
      expression: "koszt"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Roczne zużycie energii [kWh]",
      "type": "number"
    },
    model: {
      value: (_vm.koszt),
      callback: function($$v) {
        _vm.koszt = $$v
      },
      expression: "koszt"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Moc istalacji [kW]",
      "type": "number"
    },
    model: {
      value: (_vm.moc),
      callback: function($$v) {
        _vm.moc = $$v
      },
      expression: "moc"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-mail klienta",
      "type": "email"
    },
    model: {
      value: (_vm.moc),
      callback: function($$v) {
        _vm.moc = $$v
      },
      expression: "moc"
    }
  }), _vm._v(" "), _c('v-btn', [_vm._v("Wyślij")])], 1)], 1), _vm._v(" "), (!_vm.ready) ? _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "flex-spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "size": 200,
      "width": 7,
      "indeterminate": "",
      "color": "amber"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ })
]),[85]);


// WEBPACK FOOTER //
// static/js/app.bb60f34b66930caa0646.js